export const SORT_OPTIONS = [
    {value: "completed-reverse", label:"Completed (Newest First)"},
    {value: "completed", label:"Completed (Oldest First)"},
    {value: "name", label:"Name (A-Z)"},
    {value: "name-reverse", label:"Name (Z-A)"}
];